module.exports = __webpack_public_path__ + "assets/img/thumb-Rosemary-Health-1-Social-Static-Ad.d5551547.jpg";